import { URLUtils } from "abweb/utils/URLUtils";

/**
 * Add methods to directly interact with browser and its document.
 * Sometimes nice as this extra layer adds ability to directly spy on certain operations
 * Use BrowserCheck if simply want to determine current browser
 */
export class BrowserUtils {
  static locationReload() {
    document.location.reload(); // forceGet arg is deprecated (and we weren't using it)
  }
  static setLocationHref(href) {
    document.location.href = href;
  }
  static getLocationHref() {
    return document.location.href;
  }

  /**
   * Url protocol, up to and including the colon.  http:, https:, ...
   */
  static getLocationProtocol() {
    return document.location.protocol;
  }
  static getLocationHostname() {
    return document.location.hostname;
  }
  static getLocationHash() {
    return document.location.hash;
  }
  static setLocationHash(hash) {
    document.location.hash = hash;
  }
  static setDocumentTitle(title) {
    document.title = title;
  }
  static setDocumentLang(locale) {
    document.documentElement.lang = locale;
  }
  static windowOpen(href, name = "_blank", specs) {
    const url = href.charAt(0) === "/" // absolute?
    ? URLUtils.getAbsoluteUrl(href) : href;

    // Note that we used to validate that the window.open call did not return null, on the theory that a null return
    // value is only an indicator of error. The Edge browser returns null even though the window opens. Rather than
    // throw an exception, we're now logging a warning to the browser console.
    const openedWindow = window.open(url, name, specs);
    if (!openedWindow) {
      console.warn(`window.open(${url}, ${name}, ${specs}) returned null.`);
    }
  }

  /**
   * <p>Saves a bag-o-bytes to a local file using browser APIs only. God willing,
   * this will work across all supported browsers.
   * </p>
   * <p>This works best for content that is already on the browser (such as content displayed in an 'edit control').
   * If you need to save a LARGE file straight from the server directly to disk (bypassing browser memory)
   * using the browser 'file download' capability, then use the IIRPCService.invokeDownload method.
   * </p>
   * @param fileName Download file name to save it in.
   * Note that the file will appear as a standard downloaded file in your Downloads folder
   * @param data Data to save.
   * @param properties Options to use when creating a new Blob.
   * If your data is just a simple string, pass null and we use {type: "text/plain"}.
   * Alternatives are documented in {@link https://developer.mozilla.org/en-US/docs/Web/API/Blob/Blob}
   */
  static saveToFile(fileName, data, properties = null) {
    const options = properties || {
      type: "text/plain"
    };
    const blob = new Blob([data], options);
    if (navigator.hasOwnProperty("msSaveBlob")) {
      // IE11 & Edge
      navigator.msSaveBlob(blob, fileName);
    } else {
      // FF & Chrome - basically we create an Object URL and fake a download click on a link
      const link = document.createElement("a");
      const objectUrl = window.URL.createObjectURL(blob);
      link.href = objectUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Now be a good dooby and clean up after myself,
      // but be careful because the objectUrl is probably in use right now doing the download
      // so free the resource on a timer
      setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60000);
    }
  }
  static scaleValueByBrowserZoom(value) {
    return Math.floor(value * window.devicePixelRatio);
  }
  static isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
}
//# sourceMappingURL=BrowserUtils.js.map
